export default class FactureDetailController {
	/* @ngInject */
	constructor(
		$stateParams,
		$state,
		FacturesService,
		notification,
		FacturesCommunicationService,
		RouterHistoryService,
		$uibModal,
		ModalService,
		$translate,
		CodeAutomatiqueService,
		MassiaApplicationService,
		MassiaRightsService
	) {
		this.$stateParams = $stateParams;
		this.$state = $state;
		this.FacturesService = FacturesService;
		this.notification = notification;
		this.FacturesCommunicationService = FacturesCommunicationService;
		this.RouterHistoryService = RouterHistoryService;
		this.$uibModal = $uibModal;
		this.ModalService = ModalService;
		this.$translate = $translate;
		this.CodeAutomatiqueService = CodeAutomatiqueService;
		this.MassiaApplicationService = MassiaApplicationService;
		this.MassiaRightsService = MassiaRightsService;
	}

	$onInit() {
		this.loading = false;
		this.facture = {};

		this.regimeFiscalOptions = [
			{ id: 1, libelleKey: 'FACTURES.FACTURE_X.REGIME_FISCAL_INTRACOMMUNAUTAIRE' },
			{ id: 2, libelleKey: 'FACTURES.FACTURE_X.REGIME_FISCAL_AUTOLIQUIDATION' },
			{ id: 3, libelleKey: 'FACTURES.FACTURE_X.REGIME_FISCAL_EXPORT' },
			{ id: 4, libelleKey: 'FACTURES.FACTURE_X.REGIME_FISCAL_EXONERATION' },
			{ id: 5, libelleKey: 'FACTURES.FACTURE_X.REGIME_FISCAL_FRANCHISE' },
			{ id: 6, libelleKey: 'FACTURES.FACTURE_X.REGIME_FISCAL_HORSCHAMP' }
		];

		this.closeAllOnglets();
		this.openAllOnglets();
		this.openFirstOnglet();

		this.initFacture();
	}

	hasZeroVATLines() {
		return ((this.facture.dataById && this.facture.dataById.factureArticles) || []).some((a) => a.tauxTVA == 0);
	}

	regimeFiscalLibelleKey() {
		const opt = this.regimeFiscalOptions.find((o) => o.id == (this.facture.dataById && this.facture.dataById.regimeFiscalFactureX));
		return opt ? opt.libelleKey : '';
	}

	async initFacture() {
		this.facture = {
			id: this.$stateParams.id
		};
		if (this.id) {
			this.facture = {
				id: this.id
			};
		}

		if (this.facture.id) {
			this.startLoading();

			try {
				// on ajoute await afin de ne pas passer trop rapidement dans le finally
				// et ainsi on garde le loading le temps nécessaire
				this.facture.dataById = await this.FacturesService.getFactureById(this.facture.id);

				// Si le navigateur est contrôler par un logiciel de test automatisé
				if (navigator.webdriver) {
					sessionStorage.setItem('factureSelenium', JSON.stringify(this.facture.dataById));
				}
			} catch (ex) {
				if (ex.status === 404) {
					this.goListFacture();
				}
				this.notification.error(ex.data);
			} finally {
				this.getDomaine();
				this.stopLoading();
			}
		} else {
			this.goListFacture();
		}
		this.code = await this.codeAuto();
	}
	async codeAuto() {
		try {
			const code = await this.CodeAutomatiqueService.getCodeAutomatique(this.MassiaApplicationService.getApplication());

			const res = code.find((x) => x.domaineCode.toLowerCase() === 'factures'.toLowerCase());

			return res;
		} catch (err) {
			console.error(err);
		}
	}
	goListFacture() {
		this.$state.go(
			'factures.list',
			{
				obj: null,
				fromFactureDetail: true
			},
			{ reload: true }
		);
	}

	openFirstOnglet() {
		this.ongletOpen = {
			isEnteteOpen: true,
			isRecapitulatifOpen: false,
			isArticlesParChantierOpen: false
		};
	}
	closeAllOnglets() {
		this.ongletOpen = {
			isEnteteOpen: false,
			isRecapitulatifOpen: false,
			isArticlesParChantierOpen: false
		};
	}
	openAllOnglets() {
		this.ongletOpen = {
			isEnteteOpen: true,
			isRecapitulatifOpen: true,
			isArticlesParChantierOpen: true
		};
	}

	getDomaine() {
		switch (this.facture.dataById.idTypeFacture) {
			case 0:
			case 2:
			case 5:
			case 6:
				this.domaine = 'factures';
				break;
			case 4:
			case 9:
				this.domaine = 'avoirmanuel';
				break;
			case 3:
			case 8:
				this.domaine = 'avoirauto';
				break;
			case 1:
				this.domaine = 'facturemanuel';
				break;
		}
	}

	annuler() {
		if (this.modalInstance) {
			this.fermerModal();
		} else {
			this.retournerListeFactures();
		}
	}

	fermerModal() {
		this.modalInstance.close('close');
	}

	retournerListeFactures() {
		if (!this.RouterHistoryService.back()) {
			this.goListFacture();
		}
	}

	print() {
		this.ModalService.open({
			component: 'facturesPrint',
			windowClass: 'modern-modal print-facture-modal',
			animation: true,
			size: 'l',
			backdrop: false,
			resolve: {
				source: () => [this.facture.id],
				idSociete: () => this.facture.dataById.idSociete,
				selectedFactures: () => [{ ...this.facture.dataById, id: this.facture.id }],
				isSendingMail: () => this.isSendingMail
			}
		});
	}

	async regenerer() {
		const modalInstance = this.ModalService.confirm({
			modalTitle: this.$translate.instant('FACTURES.REGENERER.TITLE'),
			modalMsg: this.$translate.instant('FACTURES.REGENERER.MESSAGE'),
			headerClass: 'modal-danger'
		});
		const that = this;
		modalInstance.result.then(async function () {
			that.regenererFacture();
		});
	}

	async regenererFacture(comptoirWithFiles = false) {
		this.startLoading();
		try {
			const tmp = await this.FacturesService.regenererFacture(this.facture.id, comptoirWithFiles);
			if (tmp) {
				this.notification.info(this.$translate.instant('FACTURES.REGENERER.ERROR'));
			}
			return tmp;
		} catch (err) {
			if (err.data) {
				this.notification.error(err.data);
			} else {
				throw err;
			}
		} finally {
			this.stopLoading();
			this.initFacture();
		}
	}

	sendMail = async () => {
		try {
			const mailDestinataireModal = this.ModalService.open({
				component: 'ModaleChooseDestinataire',
				resolve: {
					idSociete: () => this.facture.dataById.idSociete,
					selectedFactures: () => [{ ...this.facture.dataById, id: this.facture.id }]
				},
				animation: true,
				size: 'xxl',
				windowClass: 'modern-modal'
			});

			const res = await mailDestinataireModal.result;
			if (res.length > 0) {
				this.isSendingMail = true;
				this.notification.info(this.$translate.instant('FACTURES.ENVOI_MAIL_START'));
				var response = await this.FacturesService.sendFacturesByMail(res);
				let r = '';
				if (response?.length > 0) {
					for (let i = 0; i < response.length; i++) {
						r = r + response[i] + '<br />';
					}
					this.ModalService.info({
						modalTitle: this.$translate.instant('FACTURES.BREADCRUMBS.FACTURES_LIST'),
						modalMsg: r,
						headerClass: 'modal-info'
					});
				} else {
					this.notification.success(this.$translate.instant('FACTURES.ENVOI_MAIL_FIN'));
				}
			}
		} catch (e) {
			console.error(e);
		}
	};
	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}

	async openModaleComptant() {
		const modalInstance = this.ModalService.open({
			component: 'modaleUpdateComptant',
			animation: true,
			size: 'lg',
			resolve: {
				facture: () => this.facture.dataById
			}
		});

		try {
			const res = await modalInstance.result;
			if (res === 'updated') {
				this.notification.info('FACTURES.REGENERER.TITLE');
			}
		} catch (ex) {
			console.log('🔥: FactureDetailController -> openModaleComptant -> ex', ex);
		}
	}

	openNewWindow(routeName, params) {
		const url = this.$state.href(routeName, params);
		window.open('gestion.html' + url);
	}
}
